/* eslint-disable no-console */
import CONFIG from '@/config';

// eslint-disable-next-line import/no-anonymous-default-export
export default {
    setItem(key, val) {
        try {
            localStorage.setItem(CONFIG.cachePrefix + key, JSON.stringify(val));
        } catch (err) {
            console.error(err);
        }
    },

    getItem(key) {
        let val = localStorage.getItem(CONFIG.cachePrefix + key);
        if (!val) return null;
        try {
            return JSON.parse(val);
        } catch (err) {
            return val;
        }
    },

    delItem(key) {
        localStorage.removeItem(CONFIG.cachePrefix + key);
    },

    // 清空全部缓存
    clearAll() {
        localStorage.clear();
    },
    /**
     * sessionStorage 操作
     */
    setSessionItem(key, val) {
        try {
            sessionStorage.setItem(CONFIG.cachePrefix + key, JSON.stringify(val));
        } catch (err) {
            console.error(err);
        }
    },
    /**
     * sessionStorage 操作
     */
    getSessionItem(key) {
        let val = sessionStorage.getItem(CONFIG.cachePrefix + key);
        if (!val) return null;
        try {
            return JSON.parse(val);
        } catch (err) {
            return val;
        }
    },
    /**
     * sessionStorage 操作
     */
    delSessionItem(key) {
        sessionStorage.removeItem(CONFIG.cachePrefix + key);
    },

    // 清空全部缓存
    clearSessionAll() {
        sessionStorage.clear();
    },

    //获取请求头数据信息
    getHeaders() {
        //平台请求头
        const _headers = this.getHeader('headers');
        let HttpHeaders = {..._headers };
        //固定头
        HttpHeaders['platType'] = CONFIG.platType;
        HttpHeaders.currentType = CONFIG.currentType;
        HttpHeaders['Content-Type'] = 'application/json';

        return HttpHeaders;
    },

    //获取请求头数据信息
    getHeader(files) {
        let HttpHeaders = {};
        //当前系统请求头
        CONFIG[files].forEach((item) => {
            HttpHeaders[item] = this.getSessionItem(item) || '';
        });
        return HttpHeaders;
    },

    //获取请求头参数
    getHead() {
        return this.getHeader('headers');
    },

    //判断是否有登录当前系统
    isLogin() {
        return this.isLog('headers');
    },

    isLog(headerType) {
        const _len = CONFIG[headerType].length;
        for (let i = 0; i < _len; i++) {
            const _item = CONFIG[headerType][i];
            if (!this.getSessionItem(_item)) return false;
        }
        return true;
    }
};